module.exports = __webpack_public_path__ + "img/team-building-dentist.8c4be6b8.png";